import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {
          title: '首页',
          icon: 'home'
        }
      }
    ]
  }
]

export const asyncRouterMap = [

  {
    path: '/wxNumber',
    component: Layout,
    redirect: 'wxNumber/index',
    name: 'wxNumber',
    meta: {
      title: '微信账号',
      icon: 'ums'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/wxNumber/index'),
      meta: {
        title: '微信账号',
        icon: 'icon-icon_zhanghao'
      }
    }]
  },


  {
    path: '/fans',
    component: Layout,
    redirect: '/fans/index',
    name: 'fans',
    meta: {
      title: '粉丝管理',
      icon: 'ums'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/fans/index'),
      meta: {
        title: '粉丝管理',
        icon: 'icon-fensi'
      }
    }]
  },


  {
    path: '/extension',
    component: Layout,
    redirect: '/extension/information',
    name: 'extension',
    meta: {
      title: 'SMS推广',
      icon: 'extension'
    },
    children: [
      {
        path: 'information',
        name: 'information',
        component: () => import('@/views/information/index'),
        meta: {
          title: '推广管理',
          icon: 'icon-28gongyegongcheng_shujuxinxi'
        }
      },
      {
        path: 'passageway',
        name: 'passageway',
        component: () => import('@/views/passageway/index'),
        meta: {
          title: '通道管理',
          icon: 'tongdao'
        }
      },
      {
        path: 'passagewayPay',
        name: 'passagewayPay',
        component: () => import('@/views/passageway/recharge'),
        meta: {
          title: '通道充值',
          icon: 'tongdao'
        },
        hidden:true

      },
      {
        path: 'dataSend',
        name: 'dataSend',
        component: () => import('@/views/dataSend/index'),
        meta: {
          title: '推广发送',
          icon: 'icon-fasongyoujian'
        }
      }
    ]
  },

  {
    path: '/sourceGoods',
    component: Layout,
    redirect: '/sourceGoods/index',
    name: 'sourceGoods',
    meta: {
      title: '货源管理',
      icon: 'ums'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/source_goods/index'),
      meta: {
        title: '货源管理',
        icon: 'icon-huoyuanguanli'
      }
    }]
  },


  {
    path: '/notepad',
    component: Layout,
    redirect: '/notepad/expenditure',
    name: 'notepad',
    meta: {
      title: '记事本',
      icon: 'notepad'
    },
    children: [
      {
        path: 'expenditure',
        name:"expenditure",
        component: () => import('@/views/notepad/expenditure/index'),
        meta: {
          title: '支出管理',
          icon: 'expenditure'
        }
      },
      {
        path: 'income',
        name:"income",
        component: () => import('@/views/notepad/income/index'),
        meta: {
          title: '收入管理',
          icon: 'income'
        }
      }
    ]
  },



  {
    path: '/order',
    component: Layout,
    redirect: '/order/index',
    name: 'order',
    meta: {
      title: '订单管理',
      icon: 'ums'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/order/index'),
        meta: {
          title: '订单管理',
          icon: 'icon-dingdan',
          keepAlive:true
        }
      },
      {
        path: 'trajectory',
        name: 'trajectory',
        component: () => import('@/views/order/trajectory'),
        meta: {
          title: '订单详情',
          icon: 'ums-admin',
        },
        hidden:true
      },
    ]
  },

  {
    path: '/detailed',
    component: Layout,
    redirect: '/detailed/index',
    name: 'detailed',
    meta: {
      title: '订单明细',
      icon: 'ums'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/detailed/index'),
      meta: {
        title: '订单明细',
        icon: 'icon-xiaoshou',
        keepAlive:true
      }
    },{
        path: 'orderDetailed',
        name: 'orderDetailed',
        component: () => import('@/views/detailed/trajectory'),
        meta: {
          title: '订单详情',
          icon: 'ums-role'
        },
        hidden:true
      },
    ]
  },

  {
    path: '/settlement',
    component: Layout,
    redirect: '/settlement/index',
    name: 'settlement',
    meta: {
      title: '提成结算',
      icon: 'ums'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/settlement/index'),
      meta: {
        title: '提成结算',
        icon: 'icon-tichengguize',
        keepAlive:true
      }
    }]
  },



  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {
          title: '用户列表',
          icon: 'ums-admin'
        }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {
          title: '角色列表',
          icon: 'ums-role'
        }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: '分配菜单'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: '分配资源'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {
          title: '菜单列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: '添加菜单'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: '修改菜单'
        },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {
          title: '资源列表',
          icon: 'ums-resource'
        }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: '资源分类'
        },
        hidden: true
      },

      {
        path: 'team/index',
        component: () => import('@/views/team/index'),
        meta: {
          title: '团队管理',
          icon: 'icon-tuandui'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js